import React from 'react';
import styles from './InfoInput.module.css';

const InfoInput = ({ question }) => {
    const items = question.items || [];
    const content = question.content || '';
    const variant = question.variant || 'numbered'; // 'numbered' or 'plain'
    const isPlain = variant === 'plain';

    // If content is provided, render it as plain text (supports \n for line breaks)
    if (content) {
        return (
            <div className={`${styles.infoContainer} ${styles.plainContainer}`}>
                {content.split('\n').map((line, index) => (
                    <div key={index} className={`${styles.infoItem} ${styles.plainItem}`}>
                        <span className={`${styles.text} ${styles.plainText}`}>{line}</span>
                    </div>
                ))}
            </div>
        );
    }

    return (
        <div className={`${styles.infoContainer} ${isPlain ? styles.plainContainer : ''}`}>
            {items.map((item, index) => (
                <div key={index} className={`${styles.infoItem} ${isPlain ? styles.plainItem : ''}`}>
                    {!isPlain && <span className={styles.bullet}>{index + 1}.</span>}
                    <span className={`${styles.text} ${isPlain ? styles.plainText : ''}`}>{item}</span>
                </div>
            ))}
        </div>
    );
};

export default InfoInput;